document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('guide-bot-modal');
  if (!modal) return;

  const openButtons = document.querySelectorAll('[data-branch-guide-open]');
  const closeButtons = modal.querySelectorAll('[data-guide-bot-close]');
  const stepContainer = document.getElementById('guide-bot-step-container');

  const backBtnArea = document.getElementById('back-btn-area');
  const backToPrevButton = document.getElementById('back-to-prev');
  const backToFirstButton = document.getElementById('back-to-first');


  //----------------------------------------------------------------------
  //----------------------------------------------------------------------
  
  // 分岐定義（ここだけ更新すればOK）
  // nextオブジェクト or 遷移先のURLパスで各質問 + 回答 を定義していくだけ  
  const TREE = {
    start: {
      question: 'いらっしゃいませ、商品をどのようにお探ししましょうか？',
      options: [
        { label: 'カテゴリから探す', next: 'usage' },
        { label: 'ブランドから探す', next: 'brand' }
      ]
    },

// ---------用途から探す
    usage: {
      question: 'お探しのカテゴリを選んでください',
      options: [
        { label: 'ラケット', next: 'racket' },
        { label: 'ラバー', next: 'rubber' },
        { label: 'シューズ', next: 'shoes' },
        { label: 'ボール', next: 'ball' },
        { label: 'ウェア（ユニフォーム）', next: 'uniform' },
        { label: 'ウェア（Tシャツ・ジャージ）', next: 'tshirtJersey' },
        { label: 'ソックス・タオル', next: 'socksTowel' },
        { label: 'アクセサリー', next: 'accessory' },
        { label: 'ケース', next: 'case' },
        { label: 'バッグ', next: 'bag' },
        { label: 'メンテナンス', next: 'maintenance' },
        { label: '備品', next: 'equipment' }
      ]
    },

    // -----ラケット
        racket: {
        question: 'どの商品をお探しですか？',
        options: [
            { label: 'シェーク攻撃用', url: '/collections/shakehand-attack' },
            { label: 'シェーク守備用', url: '/collections/shake-defense' },
            { label: '中国式ペン', url: '/collections/chinapen' },
            { label: '日本式ペン', url: '/collections/nihonpen' },
            { label: '反転式ペン', url: '/collections/hantenshiki' },
            { label: 'ラバー貼りラケット', url: '/collections/rubberpasted-racket' },
            { label: '木材5枚合板', url: '/collections/5-wood-plywood-racket' },
            { label: '木材7枚合板', url: '/collections/7-wood-plywood-racket' },
            { label: 'インナーカーボン', url: '/collections/inner-carbon-racket' },
            { label: 'アウターカーボン', url: '/collections/outer-carbon-racket' }, 
        ]
        },

    // -----ラバー
        rubber: {
        question: 'どの商品をお探しですか？',
        options: [
            { label: '裏ソフト', url: '/collections/urasoft' },
            { label: '表ソフト', url: '/collections/omotesoft' },
            { label: '粒高', url: '/collections/tsubudaka' },
            { label: '一枚ラバー(OX)', url: '/collections/mei-raba' },
            { label: 'アンチ', url: '/collections/antirubber' },
            { label: 'ラージ用表ソフト', url: '/collections/largeball-rubber' },
        ]
        },

    // -----シューズ
        shoes: {
        question: 'どの商品をお探しですか？',
        options: [
            { label: 'ユニセックス', url: '/collections/siyuzu-yunisetukusu' },
            { label: 'インソール・靴ひも', url: '/collections/insole' },
            { label: 'ジュニア・キッズ用', url: '/collections/junior-kids' },
        ]
        },

    // -----ボール
        ball: {
        question: 'どの商品をお探しですか？',
        options: [
            { label: 'トレ球(40mm)', url: '/collections/trainingball' },
            { label: '試合球(40mm)', url: '/collections/threestar' },
            { label: 'トレ球(44mm)', url: '/collections/trainingball-large' },
            { label: '試合球(44mm)', url: '/collections/threestar-large' },
        ]
        },

    // -----ウェア（ユニフォーム）
        uniform: {
        question: 'どの商品をお探しですか？',
        options: [
            { label: 'シャツ（ユニセックス）', url: '/collections/wear-uniform-tops' },
            { label: 'シャツ（ウィメンズ）', url: '/collections/shirts-women' },
            { label: 'パンツ', url: '/collections/wear-uniform-pants' },
            { label: 'スコート', url: '/collections/wear-uniform-skort' },
        ]
        },

    // -----ウェア（Tシャツ・ジャージ）
        tshirtJersey: {
        question: 'どの商品をお探しですか？',
        options: [
            { label: 'Tシャツ', url: '/collections/tshirt' },
            { label: 'ジャージ', url: '/collections/tracksuits' },
            { label: 'スパッツ', url: '/collections/spats' },
        ]
        },

    // -----ソックス・タオル
        socksTowel: {
        question: 'どの商品をお探しですか？',
        options: [
            { label: 'タオル', url: '/collections/towl' },
            { label: 'ソックス', url: '/collections/sox' },
        ]
        },

    // -----アクセサリー
        accessory: {
        question: 'どの商品をお探しですか？',
        options: [
            { label: 'ストラップ・キーホルダー', url: '/collections/strap-key-holder' },
            { label: 'ゼッケンピン', url: '/collections/bib-pin' },
            { label: 'ネックレス', url: '/collections/necklace' },
            { label: 'ヘアバンド等', url: '/collections/hairband-ristband' },
            { label: 'その他', url: '/collections/akusesari-sofalseta' },
        ]
        },

    // -----ケース
        case: {
        question: 'どの商品をお探しですか？',
        options: [
            { label: 'ラケットケース', url: '/collections/racketcase' },
            { label: 'ボールケース', url: '/collections/ballcase' },
            { label: 'シューズケース', url: '/collections/shoescase' },
        ]
        },

    // -----バッグ
        bag: {
        question: 'どの商品をお探しですか？',
        options: [
            { label: 'リュック', url: '/collections/rucksack' },
            { label: 'ショルダー', url: '/collections/shoulder' },
        ]
        },

    // -----メンテナンス
        maintenance: {
        question: 'どの商品をお探しですか？',
        options: [
            { label: '接着剤', url: '/collections/glue' },
            { label: 'ラバーメンテ', url: '/collections/rubber-maintenance' },
            { label: 'サイド/グリップテープ', url: '/collections/side-tape-grip-tape' },
            { label: '保護シート', url: '/collections/rubber-cover' },
        ]
        },

    // -----備品
        equipment: {
        question: 'どの商品をお探しですか？',
        options: [
            { label: 'ネット・サポート',url: '/collections/net-support' },
            { label: '得点板',url: '/collections/scoreboard' },
            { label: 'DVD・書籍',url: '/collections/dvd-books' },
            { label: '卓球台',url: '/collections/zhuo-qiu-tai' },
            { label: 'マシン',url: '/collections/%E5%8D%93%E7%90%83%E3%83%9E%E3%82%B7%E3%83%B3table-tennis-machine' },
        ]
        },

 
// ---------ブランドから探す (個別ページが無い場合はブランド一覧に飛ばす)
    brand: {
      question: 'お探しのブランドを選んでください',
      options: [
        { label: 'バタフライ', url: '/collections/butterfly-collection' },
        { label: 'Nittaku', url: '/collections/nittaku-collection' },
        { label: 'VICTAS', url: '/collections/victas-collection' },
        { label: 'MIZUNO', url: '/collections/mizuno' },

        { label: 'asics', url: '/collections/asics-collection' },
        { label: 'andro', url: '/collections/andro-collection' },
        { label: 'アームストロング', url: '/collections/armstrong-collection' },
        { label: 'STIGA', url: '/collections/stiga-collection' },
        
        { label: 'TIBHAR', url: '/collections/tibhar-collection' },
        { label: 'ヤサカ', url: '/collections/yasaka' },
        { label: 'JOOLA', url: '/collections/joola-collection' },
        { label: 'DARKER', url: '/collections/darker-collection' },
       
        { label: 'Rallys', url: '/collections/rallys' },
        { label: 'UeA', url: '/collections/uea' },
        { label: 'TSP', url: '/collections/tsp' },
        { label: 'DONIC',url: '/collections/donic' },
        { label: 'エクシオン',url: '/collections/xiom-collection' }
      ]
    }

  };

  //----------------------------------------------------------------------
  //----------------------------------------------------------------------



  let currentStep = 'start';
  let historyStack = [];
  let lastFocusedElement = null;

  // 起動ボタンを隠す
    function setOpenButtonsHidden(hidden) {
    openButtons.forEach(function (button) {
      button.classList.toggle('is-hidden', hidden);
      button.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    });
  }

  function openModal() {
    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');

    setOpenButtonsHidden(true);

    historyStack = [];
    renderStep('start');

    const focusTarget = modal.querySelector('.guide-bot-modal__close');
    if (focusTarget) focusTarget.focus();
  }

  function closeModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');

    setOpenButtonsHidden(false);

    if (lastFocusedElement) {
      lastFocusedElement.focus();
    }
  }

  function renderStep(stepKey) {
    const step = TREE[stepKey];
    if (!step) return;

    currentStep = stepKey;

    stepContainer.innerHTML = `
      <div class="guide-bot-step">
        <p class="guide-bot-step__question">${escapeHtml(step.question)}</p>
        <div class="guide-bot-step__options">
          ${step.options.map(function (option, index) {
            return `
              <button
                type="button"
                class="guide-bot-step__option"
                data-guide-bot-option-index="${index}"
              >
                ${escapeHtml(option.label)}
              </button>
            `;
          }).join('')}
        </div>
      </div>
    `;

    updateNavButtons();

    const optionButtons = stepContainer.querySelectorAll('[data-guide-bot-option-index]');
    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const index = Number(button.dataset.guideBotOptionIndex);
        const selected = step.options[index];
        if (!selected) return;

        if (selected.next) {
          historyStack.push(currentStep);
          renderStep(selected.next);
          return;
        }

        if (selected.url) {
          window.location.href = selected.url;
          closeModal();
        }
      });
    });
  }

  function updateNavButtons() {
    const isAtStart = currentStep === 'start';
    backBtnArea.hidden = isAtStart;

    if (isAtStart) return;

    backToPrevButton.disabled = historyStack.length === 0;
    backToPrevButton.style.opacity = historyStack.length === 0 ? '0.5' : '1';
    backToPrevButton.style.pointerEvents = historyStack.length === 0 ? 'none' : 'auto';
  }

  function goBackToPrev() {
    const prev = historyStack.pop();
    if (!prev) return;
    renderStep(prev);
  }

  function goBackToFirst() {
    historyStack = [];
    renderStep('start');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  openButtons.forEach(function (button) {
    button.addEventListener('click', openModal);
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeModal);
  });

  if (backToPrevButton) {
    backToPrevButton.addEventListener('click', goBackToPrev);
  }

  if (backToFirstButton) {
    backToFirstButton.addEventListener('click', goBackToFirst);
  }

  document.addEventListener('keydown', function (event) {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      closeModal();
    }
  });
});